import React from "react";
import { motion } from "framer-motion";
import { Award, Building2, Landmark, Briefcase } from "lucide-react";
const items = [
  { icon: Award, title: "ANCORD", text: "Assessor de Investimentos credenciado pela Associação Nacional das Corretoras e Distribuidoras de Títulos e Valores Mobiliários, Câmbio e Mercadorias." },
  { icon: Building2, title: "Ademicon Novo Hamburgo", text: "Consultor autorizado da maior administradora independente de consórcios do Brasil." },
  { icon: Landmark, title: "Banco Central", text: "Todas as operações regulamentadas e fiscalizadas pelo Banco Central do Brasil." },
  { icon: Briefcase, title: "25+ Anos de TI", text: "Rigor analítico, pensamento sistêmico aplicado à construção patrimonial." },
];
export default function Credentials() {
  return (
    <section className="py-24 lg:py-32 relative" data-testid="credentials">
      <div className="container">
        <div className="max-w-3xl mb-16">
          <div className="eyebrow mb-4"><span className="kicker-line" />Credenciais</div>
          <h2 className="text-4xl md:text-5xl font-display font-light">Confiança que se <span className="italic text-gold-gradient">verifica</span>.</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
          {items.map((it, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
              className="group bg-background hover:bg-card-gradient p-8 transition-colors">
              <it.icon className="text-primary mb-6 group-hover:scale-110 transition-transform" size={28} />
              <h3 className="font-display text-xl mb-3">{it.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{it.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
